/**
 * Trusted Partner profile copy (FR-28, MYN-104). Its own file rather than an
 * addition to `lib/constants/ui-strings.ts`: that file is already at 562
 * lines with its own `TODO(decompose)` marker (mnr-standards yellow band -
 * "the next change to this file MUST include or precede a split"). Splitting
 * a 562-line shared file is unrelated, out-of-scope work for this ticket
 * (BP-6), so this module's copy lives locally instead of growing it further.
 */
export const PARTNER_PROFILE_STRINGS = {
  SAVE: 'Save',
  CANCEL: 'Cancel',
  LOGO_LABEL: 'Logo',
  LOGO_UPLOAD_CAPTION: 'Upload Logo',
  LOGO_HINT: 'Required. Square, about 512 × 512 px. Shown as a circle.',
  LOGO_REQUIRED: 'Add your logo to save.',
  LOGO_REPLACE_CAPTION: 'Replace Logo',
  LOGO_TOO_LARGE: 'Image is too large. Please choose a smaller file.',
  LOGO_UPLOAD_ERROR: 'Upload failed. Please try again.',
  LOGO_WRONG_TYPE: 'Please choose a PNG or JPG file.',
  COVER_PHOTO_LABEL: 'Cover Photo',
  COVER_PHOTO_HINT:
    'Required. The banner across the top of your profile page, about 1600 × 460 px. PNG or JPG, up to 5 MB.',
  COVER_PHOTO_REQUIRED: 'Add your cover photo to save.',
  LISTING_COVER_LABEL: 'Listing Cover',
  LISTING_COVER_HINT:
    'Optional. Shown behind your logo on the partner directory, about 800 × 400 px (2:1). PNG or JPG, up to 5 MB. Without one, your Cover Photo is used.',
  LISTING_COVER_UPLOAD: 'Upload Listing Cover',
  LISTING_COVER_REPLACE: 'Replace Listing Cover',
  COVER_PHOTO_UPLOAD: 'Upload Cover Photo',
  COVER_PHOTO_REPLACE: 'Replace Cover Photo',
  COVER_PHOTO_TOO_LARGE: 'That file is too large. Please choose a smaller PNG or JPG.',
  COVER_PHOTO_UPLOAD_ERROR: 'Could not upload this file. Please try again.',
  IDENTITY: 'Identity & Contact',
  BUSINESS_NAME: 'Business Name',
  CONTACT_NAME: 'Contact Name',
  CONTACT_TITLE: 'Contact Title',
  EMAIL: 'Email',
  EMAIL_LOCKED_HINT: 'Email cannot be changed here.',
  PHONE: 'Phone',
  WEBSITE: 'Website URL',
  SCHEDULING: 'Scheduling link',
  SCHEDULING_HINT: 'Used for the Schedule button when "Scheduling link" is selected below.',
  CONTACT_PREFERENCE_LABEL: 'How should members reach you?',
  CONTACT_PREFERENCE_EMAIL: 'Inquiry email',
  CONTACT_PREFERENCE_SCHEDULING: 'Scheduling link',
  CONTACT_PREFERENCE_HINT: 'Members see one contact button on your profile page.',
  SCHEDULING_REQUIRED: 'Add your scheduling link first',
  SCHEDULING_CLICKS: 'Scheduling clicks',
  EMAIL_CONTACT_CLICKS: 'Email contact clicks',
  BIO: 'Bio / Introduction',
  FEATURED_TRUSTED_PARTNER: 'Featured Trusted Partner',
  FEATURED_YES: 'Featured',
  FEATURED_NO: 'Not Featured',
  SERVICES: 'Services & Categories',
  SERVICE_CATEGORIES: 'Service Categories',
  SERVICES_OFFERED: 'Services Offered',
  SERVICES_OFFERED_PLACEHOLDER: 'Type a service and press Enter',
  TAGLINE: 'Tagline',
  TAGLINE_MAX_LENGTH: 100,
  ONLINE_PRESENCE: 'Online Presence',
  LINKEDIN: 'LinkedIn URL',
  PROMO_VIDEO: 'Promo Video URL',
  CONTACT_EMAIL_FOR_INQUIRIES: 'Contact Email for Inquiries',
  CONTACT_EMAIL_FOR_INQUIRIES_HINT: 'This email receives member inquiries — can be different from your login email.',
  DELETE_PROFILE: 'Delete Profile',
  DELETE_CONFIRM_TITLE: 'Delete Trusted Partner Profile?',
  DELETE_CONFIRM_BODY: 'This removes your profile from the member directory. This cannot be undone.',
  DELETE_CONFIRM_ACTION: 'Delete Profile',
  SAVE_SUCCESS: 'Profile saved.',
  SAVE_ERROR: 'Could not save your profile. Please try again.',
  DELETE_SUCCESS: 'Profile deleted.',
  DELETE_ERROR: 'Could not delete your profile. Please try again.',
  // Profile header and cards (MYN-217, profile-redesign FR-176/FR-177).
  IMAGES: 'Logo & Cover',
  CONTACT_BUTTON: 'Contact button',
  // The member-facing labels the public partner page shows (trusted-partners
  // `CONTACT` / `SCHEDULE`), so the preview reads exactly like the real button.
  CONTACT_BUTTON_EMAIL: 'Contact',
  CONTACT_BUTTON_SCHEDULING: 'Schedule a meeting',
  CONTACT_METHOD_STAT: 'Members reach you by',
  UNTITLED_PARTNER: 'Untitled Partner',
  // Cards and header, worded as in the client-approved mockup (MYN-217, FR-176/FR-177).
  ABOUT: 'About',
  SERVICES_CARD: 'Services & categories',
  ONLINE_CARD: 'Online presence',
  VIEW_PUBLIC_PROFILE: 'View Public Profile',
  FACT_CONTACT: 'Contact',
  FACT_TITLE: 'Title',
  FACT_PHONE: 'Phone',
  FACT_LOGIN_EMAIL: 'Login email',
  FACT_INQUIRY_EMAIL: 'Inquiry email',
  FACT_WEBSITE: 'Website',
  CONTACT_BUTTON_INTRO: 'Members see one button on your page. Yours is:',
  CONTACT_BUTTON_OPENS: (target: string) => `Opens ${target}`,
  NO_SERVICES: 'No services listed yet.',
  LINKEDIN_LABEL: 'LinkedIn',
  PROMO_VIDEO_LABEL: 'Promo video',
  SCHEDULING_CLICKS_NOTE: 'Members who opened your link',
  EMAIL_CONTACT_CLICKS_NOTE: 'Inquiry email opened',
  SERVICES_LISTED: 'Services listed',
  ACROSS_CATEGORIES: (count: number) => `Across ${count} ${count === 1 ? 'category' : 'categories'}`,
} as const;
